import { Theme, alpha } from "@mui/material";
import {
  getRelativeFontSize,
  mediumFont,
  primaryColorWhite,
  regularFont,
  theme,
} from "utils/styles";

const homeStyles = {
  backImg: {
    minHeight: "100vh",
    height: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    alignItems: "center",
  },
  headerText: {
    ...mediumFont,
    fontSize: getRelativeFontSize(50),
    color: primaryColorWhite,
    lineHeight: "5.5rem",
    [theme.breakpoints.down("lg")]: {
      fontSize: getRelativeFontSize(40),
      lineHeight: "5rem",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: getRelativeFontSize(30),
      lineHeight: "4.5rem",
    },
  },
  subHeaderText: {
    ...regularFont,
    fontSize: getRelativeFontSize(4),
    color: "#c7c8c9",
    linHeight: "19px",
    [theme.breakpoints.down("lg")]: {
      fontSize: getRelativeFontSize(3),
    },
    [theme.breakpoints.down("md")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  ourServiceBtn: {
    border: "none",
    minWidth: "200px",
    height: "50px !important",
  },
  downArrowWrapper: {
    padding: "10px 12px",
    border: "1px solid #c7c8c9",
    borderRadius: "50%",
  },
  scrollDownText: {
    ...regularFont,
    fontSize: getRelativeFontSize(2),
    color: "#c7c8c9",
  },
  gradientText: {
    background:
      "linear-gradient(90deg, #ff68cc 0%, #dc5fff 33%, #a080ff 67%, #7f99ff 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    ...mediumFont,
    fontSize: getRelativeFontSize(12),
    width: "fit-content",
    [theme.breakpoints.down("md")]: {
      fontSize: getRelativeFontSize(10),
    },
  },
  heroDecorationWrapper: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    margin: 0,
    backgroundColor: "transparent",
  },
  heroDecorationImage1: {
    position: "relative",
    height: "0px",
    width: "0px",
    top: "170px",
    left: "150px",
    zIndex: 0,
    [theme.breakpoints.down("lg")]: {
      top: "100px",
      left: "80px",
    },
  },
  heroImage: {
    width: "100%",
    height: "100%",
    maxHeight: "550px",
    maxWidth: "550px",
    position: "relative",
    zIndex: 1,
  },
  heroDecorationImage2: {
    position: "relative",
    height: "0px",
    width: "0px",
    bottom: "275px",
    right: "140px",
    zIndex: 0,
    [theme.breakpoints.down("lg")]: {
      bottom: "200px",
      right: "120px",
    },
  },
  contentHeaderText: {
    ...mediumFont,
    fontSize: getRelativeFontSize(36),
    color: primaryColorWhite,
    textAlign: "center",
    lineHeight: 1.2,
    [theme.breakpoints.down("md")]: {
      fontSize: getRelativeFontSize(15),
    },
  },
  calculatorHeader: {
    ...mediumFont,
    fontSize: getRelativeFontSize(5),
    color: primaryColorWhite,
    [theme.breakpoints.down("md")]: {
      fontSize: getRelativeFontSize(3),
    },
  },
  calculatorWrapper: {
    cursor: "pointer",
    position: "relative",
    p: "30px 0px 30px 30px",
  },
  selectedCalculatorWrapper: {
    "&::before": {
      content: '""',
      position: "absolute",
      left: -1,
      top: 0,
      bottom: 0,
      width: "1px",
      background:
        "linear-gradient(180deg, #ff68cc 0%, #dc5fff 33%, #a080ff 67%, #7f99ff 100%)",
      borderRadius: "2px",
    },
  },
  aboutStudioImage: {
    borderRadius: "5px",
    position: "relative",
    zIndex: 1,
    width: "100%",
    height: "auto",
    maxHeight: "300px",
    [theme.breakpoints.down("md")]: {
      maxHeight: "200px",
    },
    "@supports (-webkit-touch-callout: none)": {
      height: "auto !important",
      maxWidth: "100%",
      maxHeight: "300px",
      [theme.breakpoints.down("md")]: {
        maxHeight: "200px",
      },
    },
  },
  gradientBox: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "5px",
    background:
      "linear-gradient(90deg, #ff68cc 0%, #dc5fff 33%, #a080ff 67%, #7f99ff 100%)",
    padding: "1px",
    boxSizing: "border-box",
    transform: "translate(-15px, -15px)",
  },
  serviceWrapper: {
    height: "100%",
    width: "95%",
    borderRadius: "5px",
    background:
      "linear-gradient(90deg, #ff68cc 0%, #dc5fff 33%, #a080ff 67%, #7f99ff 100%)",
    padding: "1px",
    boxSizing: "border-box",
    margin: "0 auto",
    mt: 10,
  },
  greyBox: {
    height: "100%",
    width: "100%",
    borderRadius: "6px",
    backgroundColor: "#30384a",
  },
  serviceImage1: {
    width: "auto",
    height: "200px",
    borderRadius: "10px",
    position: "relative",
    transition: "transform 0.1s ease-out",
    bottom: "30px",
    left: "50px",
    [theme.breakpoints.down("lg")]: {
      height: "120px",
      bottom: "0px",
    },
  },
  serviceImage2: {
    width: "auto",
    height: "200px",
    borderRadius: " 10px",
    position: "relative",
    transition: "transform 0.1s ease-out",
    top: "30px",
    right: "50px",
    [theme.breakpoints.down("lg")]: {
      height: "120px",
    },
  },
  calculatorsImage: {
    width: "100%",
    height: "600px",
    borderRadius: "10px",
    [theme.breakpoints.down("md")]: {
      height: "auto",
    },
  },
  reasonBox: {
    height: "100%",
    width: "100%",
    borderRadius: "5px",
    background:
      "linear-gradient(90deg, #ff68cc 0%, #dc5fff 33%, #a080ff 67%, #7f99ff 100%)",
    padding: "1px",
    boxSizing: "border-box",
  },
  testimonialsWrapper: {
    overflowY: "auto",
    width: "100%",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  testimonialBox: {
    background: "#414a5e",
    padding: "20px 50px",
    border: "1px solid rgba(255,255,255,.1275)",
    borderRadius: "6px",
    position: "relative",
    minWidth: "500px",
    height: "fit-content",
  },
  quotIcon: {
    height: "70px",
    position: "absolute",
    top: "5px",
    left: "15px",
    opacity: 0.1,
  },
  scroller: {
    maxWidth: "100%",
    overflow: "hidden",
    "&.animated": {
      "-webkit-mask":
        "linear-gradient(90deg, transparent, white 20%, white 80%, transparent)",
      mask: "linear-gradient(90deg, transparent, white 20%, white 80%, transparent)",
    },
    ".scroller__inner": {
      display: "flex",
      paddingBlock: "1rem",
      width: "max-content",
      flexWrap: "nowrap",
      animation: "scroll 60s linear infinite",
    },
  },
  viewServiceBtn: {
    minWidth: "200px",
    height: "50px !important",
  },
  // Hero Section Styles
  heroSectionContainer: {
    position: "relative",
    height: { xs: "500px", sm: "550px", md: "600px" },
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pt: { md: "60px", xs: "20px" },
    pb: { sm: 0, xs: 2 },
  },
  heroImageContainer: (
    isLarge: boolean,
    index: number,
    themeMode: "light" | "dark"
  ) => ({
    position: "absolute" as const,
    width: isLarge
      ? { xs: "280px", sm: "320px", md: "360px" }
      : { xs: "220px", sm: "260px", md: "300px" },
    height: isLarge
      ? { xs: "380px", sm: "420px", md: "480px" }
      : { xs: "300px", sm: "340px", md: "380px" },
    overflow: "hidden",
    borderRadius: "8px",
    cursor: "pointer",
    zIndex: index === 0 ? 2 : 1,
    pointerEvents: "auto" as const,
    backfaceVisibility: "hidden" as const,
    border:
      themeMode === "dark" ? "2px solid rgba(255, 255, 255, 0.2)" : "none",
    boxShadow:
      themeMode === "dark"
        ? isLarge
          ? "0 20px 50px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(255, 255, 255, 0.15), 0 0 30px rgba(255, 255, 255, 0.1)"
          : "0 15px 40px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255, 255, 255, 0.15), 0 0 25px rgba(255, 255, 255, 0.08)"
        : isLarge
        ? "0 20px 50px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)"
        : "0 15px 40px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05)",
    transition: "all 0.7s cubic-bezier(0.34, 1.56, 0.64, 1), z-index 0.3s ease",
    transform: isLarge
      ? "perspective(1000px) rotateY(-5deg) rotateX(2deg)"
      : "perspective(1000px) rotateY(8deg) rotateX(-2deg)",
    transformOrigin: "center center",
    willChange: "transform, z-index",
    "&:hover": {
      transform: isLarge
        ? "translateY(-25px) scale(1.05) perspective(1000px) rotateY(-2deg) rotateX(5deg)"
        : "translateY(-20px) scale(1.08) perspective(1000px) rotateY(5deg) rotateX(3deg)",
      border:
        themeMode === "dark" ? "2px solid rgba(255, 255, 255, 0.3)" : "none",
      boxShadow:
        themeMode === "dark"
          ? isLarge
            ? "0 35px 70px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(255, 255, 255, 0.25), 0 0 40px rgba(255, 255, 255, 0.15)"
            : "0 30px 60px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255, 255, 255, 0.25), 0 0 35px rgba(255, 255, 255, 0.12)"
          : isLarge
          ? "0 35px 70px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.1)"
          : "0 30px 60px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.1)",
      zIndex: "10 !important" as any,
      "& .image-overlay": {
        opacity: 1,
        background:
          "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.65) 100%)",
      },
      "& .hero-image": {
        transform: "scale(1.15) rotate(3deg)",
        filter: "brightness(0.9) saturate(1.1)",
        opacity: 1,
      },
      "& .content-wrapper": {
        transform: "translateY(0) !important",
        opacity: "1 !important",
      },
      "& .title-text": {
        transform: "translateY(0) !important",
        opacity: "1 !important",
      },
      "& .description-text": {
        transform: "translateY(0) !important",
        opacity: "1 !important",
        transitionDelay: "0.2s",
      },
      "& .shine-effect": {
        left: "100%",
      },
      "& .border-glow": {
        opacity: 1,
        boxShadow:
          themeMode === "dark"
            ? "0 0 40px rgba(248, 72, 28, 0.6), inset 0 0 40px rgba(248, 72, 28, 0.2), 0 0 60px rgba(248, 72, 28, 0.3)"
            : "0 0 40px rgba(248, 72, 28, 0.5), inset 0 0 40px rgba(248, 72, 28, 0.15), 0 0 60px rgba(248, 72, 28, 0.25)",
      },
      "& .corner-accent": {
        opacity: 1,
        background:
          "linear-gradient(135deg, rgba(248, 72, 28, 0.6) 0%, rgba(248, 72, 28, 0.3) 50%, transparent 100%)",
      },
      "& .floating-particles": {
        opacity: 1,
      },
      "& .orange-overlay": {
        opacity: 1,
      },
    },
    animation:
      index === 0
        ? "fadeInUpScaleLarge 1s ease-out 0.3s both"
        : "fadeInUpScaleSmall 1s ease-out 0.6s both",
  }),
  heroImageElement: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px",
    transition: "all 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
    willChange: "transform, filter",
    display: "block",
    zIndex: 1,
  },
  heroImageElementDark: {
    filter: "brightness(1.15) contrast(1.1)",
  },
  imageOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 55%, rgba(0,0,0,0.65) 100%)",
    borderRadius: "8px",
    opacity: 0,
    transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    padding: 4,
    zIndex: 2,
    pointerEvents: "none",
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    transform: "translateY(20px)",
    opacity: 0,
    transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    zIndex: 3,
    pointerEvents: "auto",
  },
  titleText: {
    color: "#ffffff",
    fontSize: { xs: "18px", sm: "20px", md: "22px" },
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "2.5px",
    textAlign: "center",
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    marginBottom: 1.5,
    transform: "translateY(15px)",
    opacity: 0,
    transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.1s",
    textShadow:
      "0 3px 12px rgba(0, 0, 0, 0.6), 0 0 20px rgba(255, 104, 204, 0.3)",
  },
  descriptionText: {
    color: "#ffffff",
    fontSize: { xs: "13px", sm: "14px", md: "15px" },
    fontWeight: 400,
    textAlign: "center",
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    maxWidth: "85%",
    transform: "translateY(15px)",
    opacity: 0,
    transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.25s",
    textShadow: "0 2px 10px rgba(0, 0, 0, 0.6)",
    lineHeight: 1.5,
  },
  borderGlow: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: "24px",
    opacity: 0,
    transition: "opacity 0.6s ease",
    pointerEvents: "none",
    zIndex: 4,
  },
  shineEffect: {
    position: "absolute",
    top: 0,
    left: "-100%",
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.5) 50%, transparent 100%)",
    transition: "left 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
    pointerEvents: "none",
    zIndex: 5,
  },
  cornerAccent: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "100px",
    height: "100px",
    background:
      "linear-gradient(135deg, rgba(248, 72, 28, 0.5) 0%, rgba(248, 72, 28, 0.3) 50%, transparent 100%)",
    opacity: 0,
    transition: "opacity 0.7s ease",
    zIndex: 3,
    borderRadius: "0 8px 0 0",
    pointerEvents: "none",
  },
  floatingParticle1: {
    position: "absolute",
    top: "20%",
    left: "15%",
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: "rgba(248, 72, 28, 0.7)",
    opacity: 0,
    transition: "opacity 0.8s ease",
    zIndex: 3,
    boxShadow: "0 0 20px rgba(248, 72, 28, 0.9)",
    animation: "floatParticle1 3s ease-in-out infinite",
  },
  floatingParticle2: {
    position: "absolute",
    bottom: "25%",
    right: "20%",
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    background: "rgba(248, 72, 28, 0.6)",
    opacity: 0,
    transition: "opacity 0.8s ease 0.2s",
    zIndex: 3,
    boxShadow: "0 0 15px rgba(248, 72, 28, 0.8)",
    animation: "floatParticle2 3.5s ease-in-out infinite 0.5s",
  },
  scrollDownButton: {
    cursor: "pointer",
    width: "fit-content",
    display: "flex !important",
    mt: 2,
  },
  // Benefits Section Styles - Timeline Layout
  timelineBenefitContent: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    padding: { xs: "16px", md: "20px 24px" },
    borderRadius: "16px",
    cursor: "pointer",
    transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05)"
        : "0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.9)",
    "&:hover": {
      transform: "translateY(-4px)",
    },
  },
  timelineBenefitIconBadge: {
    position: "relative",
    width: { xs: "60px", md: "75px" },
    height: { xs: "60px", md: "75px" },
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    zIndex: 1,
  },
  timelineBenefitIcon: {
    fontSize: { xs: "28px", md: "36px" },
    transition: "all 0.3s ease",
    zIndex: 1,
  },
  timelineBenefitTitle: {
    ...mediumFont,
    fontSize: { xs: "18px", md: "22px" },
    fontWeight: 700,
    lineHeight: 1.3,
    letterSpacing: "-0.02em",
    transition: "all 0.3s ease",
    mb: 0.5,
  },
  timelineBenefitDescription: {
    ...regularFont,
    fontSize: { xs: "14px", md: "15px" },
    lineHeight: 1.6,
    opacity: 0.85,
    transition: "all 0.3s ease",
  },
  timelineBenefitNumber: {
    position: "absolute",
    top: { xs: "-12px", md: "-16px" },
    right: { xs: "16px", md: "24px" },
    width: { xs: "36px", md: "44px" },
    height: { xs: "36px", md: "44px" },
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: { xs: "12px", md: "14px" },
    fontWeight: 700,
    transition: "all 0.3s ease",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    zIndex: 2,
  },
  // OurFeaturesSection Styles
  featuresSectionContainer: (muiTheme: Theme) => ({
    position: "relative",
    backgroundColor: muiTheme.palette.background.default,
    overflow: "hidden",
  }),
  featuresBackgroundContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "hidden",
    pointerEvents: "none",
    zIndex: 0,
  },
  featuresGradientMesh: (muiTheme: Theme) => ({
    position: "absolute",
    top: "-30%",
    left: "-30%",
    right: "-30%",
    bottom: "-30%",
    width: "160%",
    height: "160%",
    background:
      muiTheme.palette.mode === "dark"
        ? "radial-gradient(ellipse at 20% 30%, rgba(255, 255, 255, 0.2) 0%, transparent 60%), radial-gradient(ellipse at 80% 70%, rgba(248, 72, 28, 0.12) 0%, transparent 60%), radial-gradient(ellipse at 50% 50%, rgba(180, 180, 180, 0.12) 0%, transparent 60%)"
        : "radial-gradient(ellipse at 20% 30%, rgba(0, 0, 0, 0.12) 0%, transparent 60%), radial-gradient(ellipse at 80% 70%, rgba(248, 72, 28, 0.08) 0%, transparent 60%), radial-gradient(ellipse at 50% 50%, rgba(100, 100, 100, 0.07) 0%, transparent 60%)",
    filter: "blur(100px)",
    opacity: muiTheme.palette.mode === "dark" ? 0.6 : 0.6,
  }),
  featuresGridPattern: (muiTheme: Theme) => ({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage:
      muiTheme.palette.mode === "dark"
        ? `linear-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px),
         linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px)`
        : `linear-gradient(rgba(0, 0, 0, 0.05) 1px, transparent 1px),
         linear-gradient(90deg, rgba(0, 0, 0, 0.05) 1px, transparent 1px)`,
    backgroundSize: "60px 60px",
    opacity: 0.5,
  }),
  featuresGradientOrb: (muiTheme: Theme, index: number) => ({
    position: "absolute",
    left: `${10 + index * 25}%`,
    top: `${20 + index * 18}%`,
    width: `${350 + index * 150}px`,
    height: `${350 + index * 150}px`,
    borderRadius: "50%",
    background:
      muiTheme.palette.mode === "dark"
        ? index === 1
          ? `radial-gradient(circle, rgba(248, 72, 28, 0.2) 0%, rgba(248, 72, 28, 0.1) 50%, transparent 80%)`
          : `radial-gradient(circle, rgba(${
              index === 0
                ? "255, 255, 255"
                : index === 2
                ? "200, 200, 200"
                : "170, 170, 170"
            }, 0.25) 0%, rgba(${
              index === 0
                ? "255, 255, 255"
                : index === 2
                ? "200, 200, 200"
                : "170, 170, 170"
            }, 0.08) 50%, transparent 80%)`
        : index === 1
        ? `radial-gradient(circle, rgba(248, 72, 28, 0.12) 0%, rgba(248, 72, 28, 0.06) 50%, transparent 80%)`
        : `radial-gradient(circle, rgba(${
            index === 0 ? "0, 0, 0" : index === 2 ? "60, 60, 60" : "90, 90, 90"
          }, 0.15) 0%, rgba(${
            index === 0 ? "0, 0, 0" : index === 2 ? "60, 60, 60" : "90, 90, 90"
          }, 0.06) 50%, transparent 80%)`,
    filter: "blur(80px)",
    opacity: muiTheme.palette.mode === "dark" ? 0.4 : 0.4,
  }),
  featuresGeometricShape: (
    muiTheme: Theme,
    index: number,
    shapeType: string
  ) => ({
    position: "absolute",
    left: `${15 + index * 20}%`,
    top: `${15 + index * 20}%`,
    width: `${150 + index * 80}px`,
    height: `${150 + index * 80}px`,
    borderRadius: shapeType === "circle" ? "50%" : "25%",
    clipPath:
      shapeType === "polygon"
        ? index % 2 === 0
          ? "polygon(50% 0%, 0% 100%, 100% 100%)"
          : "polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)"
        : "none",
    background:
      index === 1
        ? muiTheme.palette.mode === "dark"
          ? `linear-gradient(135deg, rgba(248, 72, 28, 0.15) 0%, rgba(248, 72, 28, 0.1) 50%, rgba(248, 72, 28, 0.06) 100%)`
          : `linear-gradient(135deg, rgba(248, 72, 28, 0.12) 0%, rgba(248, 72, 28, 0.08) 50%, rgba(248, 72, 28, 0.05) 100%)`
        : muiTheme.palette.mode === "dark"
        ? `linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(220, 220, 220, 0.12) 50%, rgba(180, 180, 180, 0.08) 100%)`
        : `linear-gradient(135deg, rgba(0, 0, 0, 0.12) 0%, rgba(50, 50, 50, 0.08) 50%, rgba(100, 100, 100, 0.06) 100%)`,
    filter: "blur(30px)",
    border: `1px solid ${alpha(
      index === 1 ? "#f8481c" : muiTheme.palette.divider,
      index === 1 ? 0.2 : 0.15
    )}`,
    opacity: 0.3,
  }),
  featuresDarkOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    pointerEvents: "none",
    zIndex: 0.5,
  },
  featuresContentContainer: {
    position: "relative",
    zIndex: 1,
  },
  // Compact Card Styles (Grid Layout)
  compactCard: (muiTheme: Theme) => ({
    position: "relative",
    height: { xs: "280px", md: "320px" },
    borderRadius: "8px",
    overflow: "hidden",
    cursor: "pointer",
    background: muiTheme.palette.background.paper,
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    border: `1px solid ${alpha("#d1d1d1", 0.5)}`,
    maxWidth: { xs: "100%", md: "280px" },
    "&:hover": {
      border: `2px solid ${alpha(
        "#f8481c",
        muiTheme.palette.mode === "dark" ? 0.6 : 0.5
      )}`,
      boxShadow: `0 8px 32px ${alpha(
        "#f8481c",
        muiTheme.palette.mode === "dark" ? 0.3 : 0.2
      )}, 0 0 0 1px ${alpha("#f8481c", 0.2)}`,
    },
  }),
  compactCardImageContainer: (muiTheme: Theme) => ({
    position: "absolute",
    top: 16,
    right: 16,
    width: { xs: "70px", md: "90px" },
    height: { xs: "70px", md: "90px" },
    borderRadius: "6px",
    overflow: "hidden",
    zIndex: 1,
    border: `1px solid ${alpha(muiTheme.palette.divider, 0.15)}`,
    background: muiTheme.palette.background.paper,
    transition: "all 0.3s ease",
    "&:hover": {
      border: `2px solid ${alpha("#f8481c", 0.6)}`,
      boxShadow: `0 0 25px ${alpha("#f8481c", 0.4)}, 0 0 50px ${alpha(
        "#f8481c",
        0.2
      )}`,
      transform: "scale(1.05)",
    },
  }),
  compactCardImage: (isHovered: boolean) => ({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "all 0.3s ease",
    filter: isHovered
      ? `brightness(1.1) saturate(1.2) drop-shadow(0 0 10px ${alpha(
          "#f8481c",
          0.4
        )})`
      : "none",
  }),
  compactCardContent: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: { xs: 2.5, md: 3 },
    zIndex: 1,
  },
  compactCardTitle: (muiTheme: Theme, isHovered: boolean) => ({
    color: muiTheme.palette.text.primary,
    fontSize: { xs: "22px", md: "26px" },
    fontWeight: 700,
    letterSpacing: "-0.02em",
    lineHeight: 1.2,
    pr: { xs: "100px", md: "120px" },
    transition: "all 0.3s ease",
  }),
  compactCardDescription: {
    color: "inherit",
    fontSize: { xs: "13px", md: "14px" },
    lineHeight: 1.6,
    opacity: 0.85,
    pr: { xs: "100px", md: "120px" },
  },
  compactCardExploreText: (muiTheme: Theme, isHovered: boolean) => ({
    fontSize: "12px",
    fontWeight: 600,
    color: isHovered ? "#f8481c" : muiTheme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    transition: "all 0.3s ease",
    background: isHovered
      ? "linear-gradient(135deg, #f8481c 0%, #ff6b4a 100%)"
      : "none",
    backgroundClip: isHovered ? "text" : "none",
    WebkitBackgroundClip: isHovered ? "text" : "none",
    WebkitTextFillColor: isHovered ? "transparent" : "inherit",
  }),
  compactCardExploreIcon: (isHovered: boolean) => ({
    color: isHovered ? "#f8481c" : "inherit",
    fontSize: "18px",
    transition: "all 0.3s ease",
  }),
  compactCardShineEffect: (muiTheme: Theme) => ({
    position: "absolute",
    top: 0,
    left: "-100%",
    width: "100%",
    height: "100%",
    background: `linear-gradient(90deg, transparent 0%, ${alpha(
      "#f8481c",
      muiTheme.palette.mode === "dark" ? 0.3 : 0.25
    )} 50%, transparent 100%)`,
    zIndex: 2,
    pointerEvents: "none",
  }),
  compactCardOrangeAccent: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "60px",
    height: "60px",
    background: `linear-gradient(135deg, ${alpha(
      "#f8481c",
      0.4
    )} 0%, transparent 100%)`,
    borderRadius: "0 8px 0 0",
    zIndex: 2,
    pointerEvents: "none",
  },
  // Carousel Card Styles
  carouselCard: (muiTheme: Theme) => ({
    position: "relative",
    height: { xs: "350px", md: "400px" },
    borderRadius: "8px",
    overflow: "hidden",
    cursor: "pointer",
    background: muiTheme.palette.background.paper,
    border: `1px solid ${alpha("#d1d1d1", 0.5)}`,
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    width: "100%",
    maxWidth: { xs: "100%", md: "280px" },
    "&:hover": {
      transform: "translateY(-6px)",
      border: `2px solid ${alpha(
        "#f8481c",
        muiTheme.palette.mode === "dark" ? 0.7 : 0.6
      )}`,
      boxShadow: `0 1px 30px ${alpha(
        "#f8481c",
        muiTheme.palette.mode === "dark" ? 0.4 : 0.3
      )}, 0 0 0 2px ${alpha("#f8481c", 0.15)}`,
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        width: "50px",
        height: "50px",
        background: `linear-gradient(135deg, ${alpha(
          "#f8481c",
          0.5
        )} 0%, transparent 100%)`,
        borderRadius: "0 8px 0 0",
        zIndex: 1,
        pointerEvents: "none",
      },
    },
  }),
  carouselCardImageSection: {
    position: "relative",
    width: "100%",
    height: "55%",
    overflow: "hidden",
  },
  carouselCardImage: (isActive: boolean) => ({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
    transform: isActive ? "scale(1.05)" : "scale(1)",
  }),
  carouselCardImageOverlay: (isActive: boolean) => ({
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "40%",
    background: `linear-gradient(to top, ${alpha(
      "#f8481c",
      isActive ? 0.4 : 0.2
    )} 0%, rgba(0,0,0,${isActive ? 0.5 : 0.4}) 30%, transparent 100%)`,
    transition: "all 0.3s ease",
  }),
  carouselCardImageGlow: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "100%",
    background: `radial-gradient(ellipse at center bottom, ${alpha(
      "#f8481c",
      0.2
    )} 0%, transparent 70%)`,
    pointerEvents: "none",
    zIndex: 1,
  },
  carouselCardContent: (muiTheme: Theme, isActive: boolean) => ({
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: { xs: 3, md: 4 },
    background: muiTheme.palette.background.paper,
    borderTop: `2px solid ${alpha("#f8481c", isActive ? 0.4 : 0.1)}`,
    transition: "all 0.3s ease",
  }),
  carouselCardTitle: (muiTheme: Theme, isActive: boolean) => ({
    color: muiTheme.palette.text.primary,
    fontSize: { xs: "22px", md: "26px" },
    fontWeight: 700,
    letterSpacing: "-0.02em",
    lineHeight: 1.2,
    transition: "all 0.3s ease",
  }),
  carouselCardDescription: {
    color: "inherit",
    fontSize: { xs: "14px", md: "15px" },
    lineHeight: 1.5,
    opacity: 0.8,
  },
  carouselCardExploreText: (muiTheme: Theme) => ({
    fontSize: "12px",
    fontWeight: 600,
    color: "#f8481c",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    background: "linear-gradient(135deg, #f8481c 0%, #ff6b4a 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  }),
  carouselCardExploreIcon: {
    color: "#f8481c",
    fontSize: "16px",
    transition: "all 0.3s ease",
  },
  // Carousel Navigation Styles
  carouselNavButton: (muiTheme: Theme) => ({
    background: alpha(muiTheme.palette.background.paper, 0.5),
    backdropFilter: "blur(20px)",
    border: `1px solid ${alpha("#f8481c", 0.3)}`,
    "&:hover": {
      background: alpha("#f8481c", 0.1),
      border: `1px solid ${alpha("#f8481c", 0.6)}`,
      transform: "scale(1.1)",
      boxShadow: `0 0 20px ${alpha("#f8481c", 0.4)}`,
    },
    transition: "all 0.3s ease",
  }),
  carouselNavIcon: {
    fontSize: "18px",
    color: "#f8481c",
  },
  carouselDotIndicator: (muiTheme: Theme, isActive: boolean) => ({
    width: isActive ? "32px" : "8px",
    height: "8px",
    borderRadius: "4px",
    background: isActive
      ? `linear-gradient(90deg, #f8481c 0%, #ff6b4a 100%)`
      : alpha(muiTheme.palette.divider, 0.5),
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: isActive ? `0 0 10px ${alpha("#f8481c", 0.5)}` : "none",
    "&:hover": {
      background: isActive
        ? `linear-gradient(90deg, #f8481c 0%, #ff6b4a 100%)`
        : alpha("#f8481c", 0.4),
      boxShadow: `0 0 15px ${alpha("#f8481c", 0.6)}`,
    },
  }),
  // CTA Section Styles
  featuresCTASection: (muiTheme: Theme) => ({
    position: "relative",
    padding: { md: 6, xs: 4 },
    borderRadius: "8px",
    background:
      muiTheme.palette.mode === "dark"
        ? alpha(muiTheme.palette.background.paper, 1)
        : alpha(muiTheme.palette.background.paper, 0.6),
    backdropFilter: "blur(30px)",
    WebkitBackdropFilter: "blur(30px)",
    border:
      muiTheme.palette.mode === "dark"
        ? `1px solid ${alpha("#f8481c", 0.3)}`
        : `1px solid ${alpha("#f8481c", 0.2)}`,
    boxShadow:
      muiTheme.palette.mode === "dark"
        ? `0 15px 50px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 0 30px ${alpha(
            "#f8481c",
            0.15
          )}`
        : `0 15px 50px rgba(0, 0, 0, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.9), 0 0 30px ${alpha(
            "#f8481c",
            0.1
          )}`,
  }),
  featuresCTATitle: (muiTheme: Theme) => ({
    color: muiTheme.palette.text.primary,
    fontSize: { xs: "24px", md: "32px" },
    textAlign: "center",
    fontWeight: 700,
    letterSpacing: "-0.02em",
    mb: 1,
    background:
      muiTheme.palette.mode === "dark"
        ? "linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 35%, #f8481c 60%, #ff6b4a 100%)"
        : "linear-gradient(135deg, #000000 0%, #000000 35%, #f8481c 60%, #ff6b4a 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundSize: "300% 300%",
    animation: "gradientShift 4s ease infinite",
  }),
  featuresCTADescription: {
    textAlign: "center",
    maxWidth: "550px",
    fontSize: { xs: "15px", md: "17px" },
    mb: 3,
  },
  featuresOrangeAccentLine: {
    width: "80px",
    height: "3px",
    background: `linear-gradient(90deg, #f8481c 0%, #ff6b4a 100%)`,
    borderRadius: "2px",
    mt: 2,
    mx: "auto",
  },
} as const;

export default homeStyles;
